import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '.'
import { Layer } from '@/orrm/model/layer'
import { PluralResponse } from 'coloquent'
import LayerWrapper from '@/orrm/wrapper/layer'

@Module({ name: 'layers', namespaced: true, dynamic: true, store: store })
export default class LayersModule extends VuexModule {
  layers: LayerWrapper[] = []
  loading = false
  fetched = false

  @Mutation
  setLoading (loading: boolean) {
    this.loading = loading
  }

  @Mutation
  setFetched (fetched: boolean) {
    this.fetched = fetched
  }

  @Action({ rawError: true })
  async fetchAllLayers () {
    if (this.fetched) return
    let missing = true
    let currentPage = 0
    do {
      try {
        this.setLoading(true)
        const res = await Layer
          .getQueryBuilder()
          .where('field_orrm_afficher_la_couche', '1')
          .get(currentPage)

        const data = res.getData() as Layer[]
        if (data) {
          this.setLoading(false)
          const result = Array.isArray(data) ? data : [data]
          if (result.length) {
            this.layers.push(...result.map((layer: Layer) => new LayerWrapper(layer)))
          } else {
            missing = false
          }
        }
        currentPage = (res as PluralResponse).getPageNumber() + 1
      } catch (e) {
        console.error(e)
        this.setLoading(false)
      }
    } while (missing)
    this.setFetched(true)
  }
}
